import SkeletonBox from '../skeleton-box/skeleton-box.vue';

import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-table-mock',
  components: {
    'bpc-skeleton-box': SkeletonBox,
  },
})
export default class TableMock extends Vue {
  @Prop({ type: Number, default: 10 }) readonly nColumns: number;
  @Prop({ type: Number, default: 10 }) readonly nRows: number;

  /* Lifecycle hooks */
  // created () { }

  // mounted () { }

  // updated () { }

  // destroyed () { }
  get fields() {
    const res = [];
    for (let i = 0; i < this.nColumns; i++) {
      res.push({
        key: `mock_${i}`,
        label: '',
        class: 'mock-field',
      });
    }
    return res;
  }

  get items() {
    const res = [];
    for (let i = 0; i < this.nRows; i++) {
      const obj = {};
      for (let i = 0; i < this.nColumns; i++) {
        this.$set(obj, `mock_${i}`, '');
      }
      res.push(obj);
    }
    return res;
  }

  getCellClass() {
    const rand = Math.floor(Math.random() * 10 + 1);
    if (rand % 2) {
      return '';
    } else if (rand % 3) {
      return 'table-mock__field--sm';
    }

    return 'table-mock__field--xs';
  }
}
